import { Box, Link, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CustomAccordion from '../shared/CustomAccordion.styled';

const NavList = ({ nav, styles }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down('md'));

  return md ? (
    <CustomAccordion
      title={<Title title={nav?.title} />}
      description={<Links links={nav?.PrimaryNavL3?.map(data => data?.Link)} />}
      styles={styles}
    />
  ) : (
    <Stack>
      <Box>
        <Title title={nav?.title} styles={styles.summary} />
        <Links links={nav?.PrimaryNavL3?.map(data => data?.Link)} styles={styles.details} />
      </Box>
    </Stack>
  );
};

const Title = ({ title, styles }) => (
  <Typography variant='h6' component='p' role='heading' aria-level='2' sx={styles}>
    {title}
  </Typography>
);

const Links = ({ links, styles }) => (
  <Stack spacing={1}>
    {links?.map((link, i) =>
      link?.map(data => (
        <Link key={i} underline='hover' href={data?.link} aria-label={data?.ariaLabel}>
          <Typography variant='subtitle1' sx={styles} component='p'>
            {data?.text}
          </Typography>
        </Link>
      ))
    )}
  </Stack>
);
export default NavList;
